import { useEffect, useState } from 'react';

export const isMobile = (): boolean => {
  if (typeof window === 'undefined') return false;

  // Match Tailwind's md breakpoint: md is min-width 768px, so mobile is < 768
  const isMobileWidth = window.innerWidth < 768;

  const userAgent = navigator.userAgent.toLowerCase();
  const mobileDevices = [
    'android',
    'webos',
    'iphone',
    'ipad',
    'ipod',
    'blackberry',
    'windows phone',
    'opera mini',
    'mobile',
  ];

  const isMobileDevice = mobileDevices.some((device) => userAgent.includes(device));

  // Return true for mobile devices OR small viewport (allows responsive testing in DevTools)
  return isMobileDevice || isMobileWidth;
};

export const useIsMobile = (): boolean => {
  const [mobile, setMobile] = useState<boolean>(isMobile());

  useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobile;
};
